var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7072 11.3737C15.0977 10.9832 15.0977 10.35 14.7072 9.95952C14.3167 9.56899 13.6835 9.56899 13.293 9.95952L7.95964 15.2929C7.76438 15.4881 7.66675 15.744 7.66675 16C7.66675 16.1355 7.69373 16.2648 7.74263 16.3827C7.79143 16.5007 7.86376 16.6112 7.95964 16.7071L13.293 22.0404C13.6835 22.4309 14.3167 22.4309 14.7072 22.0404C15.0977 21.6499 15.0977 21.0167 14.7072 20.6262L11.081 17H24.0001C24.5524 17 25.0001 16.5522 25.0001 16C25.0001 15.4477 24.5524 15 24.0001 15H11.081L14.7072 11.3737Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.e165b7ab2dda6795498bc8eb45acf5ab.svg";
export { ForwardRef as ReactComponent };